import React from "react";
import LoginComponent from "./LoginComponent";

function LoginContainer(props) {
  return <LoginComponent {...props} />;
}

export default LoginContainer;
